import Vue from 'vue';
import { firestorePlugin } from 'vuefire';
import config from '../config/firebase';

Vue.use(firestorePlugin);

import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/auth';
import "firebase/storage"
import 'firebase/analytics';

const { Timestamp } = firebase.firestore

export { Timestamp }


// Get a Firestore instance
const fb = firebase.initializeApp(config);
export const analytics = fb.analytics()
// fb.analytics();

export const db = fb.firestore();

// Get a Auth instance
export const auth = fb.auth();

//Get a Storage Instance
export const storage = fb.storage();
